import axios from "@/libs/axios";
import constants from "@/constants";

export default {
  async fetchUserDetailsByToken(_, token) {
    const res = await axios.get(`${constants.baseApiUrl}/user/${token}`);
    return res.data;
  },
  async fetchUserAppSubscriptions({ commit }, payload) {
    const resObj = await axios.get(
      `${constants.baseApiUrl}/user/app-subscriptions/${payload}`
    );
    commit("SET_USER_APP_SUBSCRIPTIONS", resObj.data.data);
    return resObj.data.data;
  },
  async getOrgDetails(_, payload) {
    const resObj = await axios.get(
      `${constants.baseApiUrl}/organization/${payload}`
    );
    return resObj.data.data;
  },
};
